import React, { useContext, useEffect, useState } from "react";
import cn from "classnames";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import styles from "./getSpecter.module.sass";
import Icon from "../../../../../../components/Icon";
import Card from "../../../../../../components/Card";
import CurrencyTable from "../../../../../../components/Table";
import { getAllCurrencyAction, addCurrecyAction, filterCurrencyAction } from "../../../../../../redux/action/builds/economy/currency/currencyAction";
import Loader from "../../../../../../components/Loaders/LoaderProgress";
import EmptyState from '../../../../../../components/EmptyStates'
import Pagination from '@mui/material/Pagination';
import PaginationItem from '@mui/material/PaginationItem';
import Stack from '@mui/material/Stack';
import { Skeleton } from '@mui/material';
import SkeletonTable from '../../../../../../components/Skeleton/TableSkeleton'
import SkeletonEmptyState from "../../../../../../components/Skeleton/EmptyStateSkeleton";
import GlobalStateContext from "../../../../../../components/Context/GlobalStates/GlobalStateContext";
import { ToastContainer } from "react-toastify";
import Navigation from '../../../../../../components/Header/SecondaryNavigation'
import TransactionTable from '../../../../../../components/BuildComponents/RMC/TransactionTable'

const RMGTransactions = () => {

  const Transactions = [
    {
        "id": "4c789a00-5d66-46e0-988b-933be2700b75",
        "status": "Completed",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "2aaa23a1-f8ab-45a5-829c-47e3bb2eb1a5",
        "recipientWalletName": "dp09's wallet",
        "recipientTransactionContact": "dp09",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "time" : '10.39 PM',
        "updatedAt": "2024-02-23T12:55:16.914Z",
        "totalcount": "254"
    },
    {
        "id": "83f51d41-228d-40f1-98cb-d21a8e8aabfb",
        "status": "In-Progress",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "b1f172eb-855a-4aa4-aaab-9b2c182df142",
        "recipientWalletName": "radditz's wallet",
        "recipientTransactionContact": "radditz",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-23T12:36:23.262Z",
        "time" : '00.20 AM',
        "totalcount": "254"
    },
    {
        "id": "e37fcf62-73b9-4528-a0d6-a4c5b0f64f6b",
        "status": "In-Progress",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "4cc0d3d6-f5f2-4d11-8d5d-5866c9ad14b7",
        "recipientWalletName": "nine_nine_one's wallet",
        "recipientTransactionContact": "nine_nine_one",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-22T09:23:33.204Z",
        "totalcount": "254",
        "time" : '4.16 PM',
        
    },
    {
        "id": "05da3808-5935-4ae5-8e6b-8aa853e6b543",
        "status": "Completed",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "6657b8c8-404d-47c7-8354-ae76f2ead647",
        "recipientWalletName": "prat39's wallet",
        "recipientTransactionContact": "prat39",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-12T04:23:15.505Z",
        "totalcount": "254",
        "time" : '09.07 PM',
    },
    {
        "id": "b6172f29-88be-4c46-a00a-10fe5d7d08f0",
        "status": "Completed",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "360993a7-a7d4-494b-81f2-8aafd552fb4d",
        "recipientWalletName": "prat2497's wallet",
        "recipientTransactionContact": "prat2497",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-11T12:27:21.121Z",
        "totalcount": "254",
        "time" : '06.00 AM',
    },
    {
        "id": "482a0265-9256-4ac2-b76f-fd06df059380",
        "status": "In-Progress",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Credit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "9a22cf32-5848-4640-bf25-995ba365766a",
        "recipientWalletName": "prat387's wallet",
        "recipientTransactionContact": "prat387",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-11T12:14:54.586Z",
        "totalcount": "254",
        "time" : '07.27 PM',
    },
    {
        "id": "d504b695-6c49-41d2-b009-67ecf1135bde",
        "status": "Completed",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Debit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "fb8b3c94-de0c-42b8-b00f-d759484a4ed5",
        "recipientWalletName": "prat023's wallet",
        "recipientTransactionContact": "prat023",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-10T05:08:57.036Z",
        "totalcount": "254",
        "time" : '11.11 AM',
    },
    {
        "id": "0ab8c19e-b77b-42ba-b173-5c39b06008f7",
        "status": "Completed",
        "amount": "100",
        "active": true,
        "archive": false,
        "walletTransactionPurposeId": 8,
        "walletTransactionPurposeName": "Sign Up Bonus",
        "walletTransactionRecipientId": 3,
        "walletTransactionRecepientName": "player bonus wallet",
        "walletTransactionSourceId": 4,
        "walletTransactionSourceName": "playStarz bank",
        "walletTransactionTypeId": 2,
        "walletTransactionType": "Credit",
        "transactionEvent": null,
        "sourceWalletId": "47220400-069f-43e3-afd8-4d3597bb93e8",
        "sourceWalletName": "playstarz's wallet",
        "sourceTransactionContact": "playstarz",
        "recipientWalletId": "adab3dd8-041f-45f5-8993-4369308bb9ab",
        "recipientWalletName": "prat685's wallet",
        "recipientTransactionContact": "prat685",
        "walletTransactionModeId": 1,
        "competitionId": null,
        "createdAt": "2024-02-23",
        "updatedAt": "2024-01-09T11:54:27.675Z",
        "totalcount": "254",
        "time" : '03.15 PM',
    }
  ]

  const Currency = [
    {
      "id": 1,
      "name": "Currency One",
      "description": null,
      "iconUrl": null,
      "currencyId": "One",
      "code": "One",
      "type": "real",
      "archive" : false
    },
    {
      "id": 2,
      "name": "Currency Two",
      "description": null,
      "iconUrl": null,
      "currencyId": "Two",
      "code": "Two",
      "type": "real",
      "archive" : false
    },
    {
      "id": 3,
      "name": "Currency Three",
      "description": null,
      "iconUrl": null,
      "currencyId": "Three",
      "code": "Three",
      "type": "real",
      "archive" : false
    }
]

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const {appid} = useParams()
  
  // Pagination
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  // Filter
  const [currencyType, setCurrencyType] = useState([])
  const filters = {currencyType, setCurrencyType}
  // Search
  const [search, setSearch] = useState(null)
  // Sort
  const sortList = [{id: 1, name: 'Created At', value: 'created_at'}, {id: 2, name: 'Updated At', value: 'updated_at'}]
  const [sortValue, setSortValue] = useState({name: 'updated_at', value: 0})
  const [selectedSort, setSelectedSort] = useState('updated_at')
  const [sort, setSort] = useState([{id: 1, name: 'Ascending'}, {id : 2, name : 'Descending'}])
  const [sortIndex, setSortIndex] = useState(0)
  // User Access
  const [userAccess, setUserAccess] = useState(false)
  const globalStates = useContext(GlobalStateContext)
  // Skeleton
  const [showSkeleton, setShowSkeleton] = useState(true)
  
  const getUserAccess = () => {
    if(globalStates && globalStates.user && globalStates.user.memberAccessConfig?.length > 0){
      let appPermission = globalStates.user.memberAccessConfig.filter((obj) => (obj.projectId === appid))
      if(appPermission?.length > 0){
        setUserAccess(appPermission[0].permissions.id === 1 ? true : false)
      }
    }
  }
  
  useEffect(() => {
    getUserAccess()
  }, [])

  const onSearch = (e) => {

  }

  return(
      <>
        <ToastContainer />
        <Card layOut={`Get`} className={styles.card} classCardHead={styles.head} >
      
              <div className={styles.wrapper}>
                <TransactionTable items={Transactions}/>
              </div>
              
          </Card>
          <div className="divider"></div>
      </>
  )

};

export default RMGTransactions;